import { LucideIcon } from 'lucide-react';

export enum Page {
  HOME = 'HOME',
  CALENDAR = 'CALENDAR',
  CUSTOMERS = 'CUSTOMERS',
  STAFF = 'STAFF',
  ANALYTICS = 'ANALYTICS',
  ASSISTANT = 'ASSISTANT',
  SALON = 'SALON',
  BILLING = 'BILLING',
  INVENTORY = 'INVENTORY',
  MEDIA = 'MEDIA',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
  NOTIFICATIONS = 'notifications'
}

export interface NavItem {
  id: Page;
  label: string;
  icon: LucideIcon;
}

export interface Appointment {
  id: string;
  clientName: string;
  service: string;
  staffName: string;
  time: string;
  duration: number; // in minutes
  type: 'cut' | 'color' | 'style' | 'treatment';
  status: 'confirmed' | 'pending' | 'completed';
}

export interface StatData {
  label: string;
  value: string;
  change: number; // percentage
  trend: 'up' | 'down' | 'neutral';
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  time: string;
  type: 'info' | 'success' | 'warning' | 'alert';
  read: boolean;
}